import { Injectable, inject } from "@angular/core";

import {

  ActivatedRouteSnapshot,

  Resolve,

  RouterStateSnapshot,

} from "@angular/router";

import { Observable, of } from "rxjs";

import { catchError, switchMap } from "rxjs/operators";

import { StoreService } from "src/app/services/apps/store/store.service";

import { ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS } from "src/app/shared/constants/websocket-event-types.constants";

import {

  emptyOnboardingPotentialCasesResponse,

  resolveOnboardingPotentialCasesStoreId,

} from "../helpers/onboarding-potential-cases.helper";

import {

  OnboardingModalService,

  OnboardingPotentialCasesResponse,

} from "../onboarding-modal.service";



@Injectable({

  providedIn: "root",

})

export class CandidateClaimsFoundResolver

  implements Resolve<OnboardingPotentialCasesResponse>

{

  private onboardingModalService = inject(OnboardingModalService);

  private storeService = inject(StoreService);



  resolve(

    route: ActivatedRouteSnapshot,

    _state: RouterStateSnapshot,

  ): Observable<OnboardingPotentialCasesResponse> {

    return this.storeService.getCachedOrLoad().pipe(

      switchMap((stores) => {

        const storeId = resolveOnboardingPotentialCasesStoreId(route, stores);



        if (!storeId) {

          return of(emptyOnboardingPotentialCasesResponse());

        }



        // Reuse the response from a `prefetchOnboardingPotentialCases()` call
        // that just ran (e.g. right before this navigation) instead of
        // making an immediate duplicate GET for the same store — but not for
        // the WS "results ready" re-navigation (carries claimFound), which
        // must always do a fresh GET to pick up the now-completed job.
        const isWsResultsReadyRenavigation = route.queryParamMap.has(

          ONBOARDING_CANDIDATE_CLAIMS_FOUND_QUERY_PARAMS.CLAIM_FOUND,

        );

        // Always consume (clears it either way) so a stale entry can't leak
        // into a later, unrelated navigation to this same store.
        const ensured = this.onboardingModalService.consumeEnsuredResult(storeId);

        const reused = isWsResultsReadyRenavigation ? null : ensured;

        if (reused) {

          return of(reused);

        }



        return this.onboardingModalService

          .getOnboardingPotentialCases(storeId)

          .pipe(

            catchError(() =>

              of(emptyOnboardingPotentialCasesResponse(storeId)),

            ),

          );

      }),

      catchError(() => of(emptyOnboardingPotentialCasesResponse())),

    );

  }

}


